import "../styles/template.css";
import { MdSpaceDashboard } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { GiMiner } from "react-icons/gi";
import { IoIosPeople } from "react-icons/io";
import { MdMenuBook } from "react-icons/md";
import { RiBankFill } from "react-icons/ri";

import { RiDashboardFill } from "react-icons/ri";
import { IoStorefrontSharp } from "react-icons/io5";
import Narbar from "../components/narbar/Narbar";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { dropStore } from "../slice/storeSlice";
import { dropUser } from "../slice/webStoreUserSlice";
import { clearCart } from "../slice/sellingCarts";
import { dropWarehouse } from "../slice/warehouseSlice";
import { dropSelectedMessage } from "../slice/MessageSlice";
import { BiArrowToLeft } from "react-icons/bi";
import { emptyQueue, setIsSyncOnGoing } from "../slice/offlineQueue";
import { syncOfflineQueue } from "../tools/synOfflineQueue";
import { deleteDB } from "../tools/indexdb";
import { useIdelHandler } from "../tools/sessionHandler.js";
import { dropEmployee, setEmployee } from "../slice/employeeSlice";
import { useEffect, useState, useMemo } from "react";
import EmployeeLogin from "./employeeAppLogin/EmployeeLogin.jsx";
import { io } from "socket.io-client";
import { useRef } from "react";
import AdminSyncAlert from "../components/alerts/adminSyncAlert/AdminSyncAlert.jsx";
import { uiAlert } from "../components/alerts/customAlert/uiAlert.js";

const Template = (props) => {
  // creating a socket connection to the server

  const socket = useMemo(() => io(process.env.REACT_APP_Back_end_api_root, { transports: ["websocket"] }), []);

  const [employeeisLogined, setEmployeeisLogined] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { count, _ } = useSelector((state) => state.offlineQueue);
  const { employee } = useSelector((state) => state.employee);
  const { user } = useSelector((state) => state.webStoreUser);
  const { store } = useSelector((state) => state.store);
  const { IsSyncOnGoing } = useSelector((state) => state.offlineQueue);

  const countRef = useRef(count ?? 0);
  useEffect(() => {
    countRef.current = count ?? 0;
  }, [count]);

  useEffect(() => {
    /*  dispatch(setIsSyncOnGoing(false)); */
    // connect to socket
    //1 connect handler

    const onConnect = () => {
      const roomID = user._id;
      if (!roomID) return;
      console.log(socket.id); // x8WIv7-mJelg7on_ALbx
      socket.emit("createRoom", roomID);
    };

    //2 listen for syncOfflineQueue event from admin to sync offline queue

    const onSyncOfflineQueue = async ({ storeId }) => {
      const roomID = user._id;
      const currentCount = countRef.current;

      if (currentCount > 0) {
        uiAlert(`Admin wants to Sync data from this store. Do not perform any transactions until sync is complete.`);
        try {
          console.log(count, "signing out");
          let isStoreSyned = await syncOfflineQueue();

          if (isStoreSyned) {
            socket.emit("offlineQueueSynced", { roomID, isStoreSyned: true });
          } else {
            socket.emit("offlineQueueSynced", { roomID, isStoreSyned: false });
          }
        } catch (error) {
          console.log(error);
          socket.emit("offlineQueueSynced", { roomID, isStoreSyned: false });
        } finally {
          dispatch(setIsSyncOnGoing(false));
        }
      } else {
        console.log("No transactions to sync");

        socket.emit("offlineQueueSynced", { roomID: user._id, isStoreSyned: true, message: "No transactions to sync" });
      }
    };

    socket.on("connect", onConnect);
    socket.on("syncOfflineQueue", onSyncOfflineQueue);

    // if already connected, run connect logic now
    if (socket.connected) onConnect();
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    // check if employee is null i.e has login in esle setEmployeeisLogined in to false
    if (employee === null || Object.keys(employee).length === 0) {
      console.log("no employee logged in");

      setEmployeeisLogined(false);
    } else {
      setEmployeeisLogined(true);
    }
  }, [employee]);

  const handleClick = (e, path) => {
    if (!user.userIsSubscribed && path !== "/mystores" && path !== "/settings/profile") {
      uiAlert("Your subscription has expired. Please renew your subscription to access this feature.", "warning");
      return;
    }
    if (user.userType.userType.toLowerCase().includes("starter") && path !== "/mystores" && path !== "/settings/profile") {
      uiAlert("Your current plan does not allow access to this feature. Please upgrade your plan to access this feature.", "warning");
      return;
    }
    navigate(path);
  };

  const signOut = async () => {
    if (count) {
      console.log(count, "signing out");

      await syncOfflineQueue();
    }
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    navigate("/sign-in");
    dispatch(dropStore());
    dispatch(clearCart());
    dispatch(dropWarehouse());
    dispatch(dropSelectedMessage());
    dispatch(dropUser());
    dispatch(emptyQueue());
    dispatch(setIsSyncOnGoing(false));
    dispatch(dropEmployee());
    deleteDB();
    // if its a react Native webview
    if (window.ReactNativeWebView) {
      try {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "LOG_OUT" }));
      } catch (error) {
        console.log("error signing out from react native app", error);
      }
    }

    return;
  };
  useIdelHandler(signOut, 1000 * 60 * 60 * 5); // 5 hours idle time before signing out

  console.log(IsSyncOnGoing, "is sync on going");

  return (
    <>
      <Narbar />
      <div className='TemplateContain'>
        <div className='templateWrapper'>
          <div>
            <div>
              <div className='StorePlaceholder'>
                <img src='https://res.cloudinary.com/ebuka1122/image/upload/v1781251596/allAssets/StorelenseAd_ddtau0.png' />
              </div>
              <div className={"sideMenu"}>
                {/*   <div
                  className={location.pathname.includes("/dashboard") ? "clickedOption" : ""}
                  onClick={(e) => {
                    if (employee && employee.permissions.dashboard) {
                      handleClick(e, "/dashboard");
                    } else {
                      uiAlert("You do not have access to the dashboard", "warning");
                      return;
                    }
                  }}
                >
                  <MdSpaceDashboard size={22} />

                  <span>Dashboard</span>
                </div> */}

                <div
                  className={location.pathname.includes("/mystores") ? "clickedOption" : ""}
                  onClick={(e) => {
                    handleClick(e, "/mystores");
                    dispatch(dropStore());
                    dispatch(clearCart());
                    dispatch(dropWarehouse());
                    dispatch(dropSelectedMessage());
                  }}
                >
                  <FaStore size={20} />
                  <span>Stores</span>
                </div>
                {/*  <div className={location.pathname === "/employees" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/employees")}>
                  <GiMiner size={22} />
                  <span>Employees</span>
                </div> */}
                <div
                  className={location.pathname === "/customers" ? "clickedOption" : ""}
                  onClick={(e) => {
                    if (employee && employee.permissions?.customers) {
                      handleClick(e, "/customers");
                    } else {
                      uiAlert("You do not have access to customers", "warning");
                      return;
                    }
                  }}
                >
                  <IoIosPeople size={22} />
                  <span>Customers</span>
                </div>
                {/* <div
                  className={location.pathname === "/sales-record" ? "clickedOption" : ""}
                  onClick={(e) => {
                    if (employee && employee.permissions.salesRecords) {
                      handleClick(e, "/sales-record");
                    } else {
                      uiAlert("You do not have access to sales record", "warning");
                      return;
                    }
                  }}
                >
                  <MdMenuBook size={20} />
                  <span>Sales record</span>
                </div> */}
                {/*  <div className={location.pathname === "/payout" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/payout")}>
                  <RiBankFill size={20} />
                  <span>Payouts</span>
                </div> */}
              </div>
            </div>
            <div className='signOutDiv'>
              <div></div>
              <div onClick={() => signOut()}>
                <BiArrowToLeft size={20} />
                <span>Sign out</span>
              </div>
            </div>
          </div>
          <div>{props.children}</div>
        </div>
      </div>
      {!employeeisLogined && <EmployeeLogin signOut={signOut} />}
      {<AdminSyncAlert IsSyncOnGoing={IsSyncOnGoing} />}
    </>
  );
};

export default Template;
